// components/AddTransactionForm.jsx
import React, { useState } from 'react';
import { addTransactionsForm } from '../../lib/actions';
import { statusOfTransactions } from '../../lib/definitions';

const AddTransactionForm = ({ deliveryBoyId, onTransactionAdded }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    amount: '',
    type: '',
    description: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        delivery_boy_id: deliveryBoyId,
        amount: parseFloat(formData.amount),
        type: formData.type,
        description: formData.description
      };

      await addTransactionsForm(payload);
      
      // Reset form and notify parent
      setFormData({ amount: '', type: '', description: '' });
      if (onTransactionAdded) onTransactionAdded();
      
    } catch (error) {
      console.error("Failed to add transaction", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-thirdly rounded-xl shadow-sm  p-6 h-fit sticky top-6">
      <h2 className="text-lg font-semibold text-gray-100 mb-4 border-b pb-2">Add New Transaction</h2>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Transaction Type */}
        <div>
          <label className="block text-sm font-medium text-gray-100 mb-1">Transaction Type</label>
          <select
            required
            className="w-full rounded-lg bg-thirdly border border-secondary p-2.5 focus:ring-2 focus:ring-secondary focus:outline-none transition-all text-gray-400"
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
          >
            <option className='text-white' value="">Select Type...</option>
            {statusOfTransactions.map((status) => (
              <option className='text-whtie' key={status.id} value={status.id}>{status.name}</option>
            ))}
          </select>
        </div>

        {/* Amount */}
        <div>
          <label className="block text-sm font-medium text-gray-100 mb-1">Amount</label>
          <div className="relative">
            <input
              type="number"
              step="0.01"
              required
              className="w-full rounded-lg bg-thirdly border border-secondary text-gray-400  p-2.5 pl-3 focus:ring-2 focus:ring-secondary focus:outline-none"
              placeholder="0.00"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            />
          </div>
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-100 mb-1">Description</label>
          <textarea
            required
            rows="3"
            dir="auto" // Automatically handles Arabic/English mixing
            className="w-full rounded-lg bg-thirdly p-2.5 border border-secondary text-gray-400 focus:ring-2 focus:ring-secondary focus:outline-none"
            placeholder="Add details..."
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-secondary text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-50 flex justify-center items-center"
        >
          {loading ? 'Processing...' : 'Add Transaction'}
        </button>
      </form>
    </div>
  );
};

export default AddTransactionForm;